import { FaFont, FaRegImage, FaListUl, FaVideo,
   FaRegKeyboard, FaRegDotCircle, FaStickyNote, FaExternalLinkAlt,
    FaWpforms, FaSpinner, FaMusic, FaImages, FaPhone,
    FaCalendar, FaExclamationTriangle, FaRegPhone, FaRegEnvelope, FaPen, FaThLarge, FaDollarSign, FaRegComment, FaLevelUpAlt, FaRegIdCard, FaChartLine, FaIdCard, FaCode  
  } from 'react-icons/fa';
import { useDraggable } from '@dnd-kit/core';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import LibraryModal from '../../../../components/LibraryModal';

const ELEMENT_GROUPS = [
    {
        group: 'Texto',
        elements: [
            {
                type: 'text',
                label: 'Texto',
                icon: <FaFont className="text-gray-500" />,
                description: 'Adicione um bloco de texto',
                textColor: 'theme',
            },
            {
                type: 'alert',
                label: 'Alerta',
                icon: <FaExclamationTriangle className="text-gray-500" />,
                description: 'Adicione um alerta',
            },

        
        ],
    },
    {
        group: 'Ação',
        elements: [
            {
                type: 'button',
                label: 'Botão',
                icon: <FaRegDotCircle className="text-gray-500" />,
                description: 'Adicione um botão de ação',
                destinationType: 'step',
                target: null,
                textColor: 'theme',
                buttonColor: 'theme',
            },
              {
                  type: 'quiz',
                  label: 'Quiz',
                  icon: <FaThLarge className="text-gray-500" />,
                  description: 'Adicione um quiz',
              },
       
            {
                type: 'loading',
                label: 'Carregamento',
                icon: <FaSpinner className="text-gray-500" />,
                description: 'Adicione um indicador de carregamento',
                destinationType: 'step',
                target: null,
            },
        ],
    },
    {
      group: 'Visuais',
      elements: [
          {
              type: 'image',
              label: 'Imagem',
              icon: <FaRegImage className="text-gray-500" />,
              description: 'Adicione uma imagem',
          },
        
          {
            type: 'video',
            label: 'Vídeo',
            icon: <FaVideo className="text-gray-500" />,
            description: 'Adicione um vídeo',
        },
        {
          type: 'cards',
          label: 'Cards',
          icon: <FaRegIdCard className="text-gray-500" />,
          description: 'Adicione um cards',
      },
       

          
      ],
  },
  {
    group: 'Gráficos',
    elements: [
            {
              type: 'levels',
              label: 'Nível',
              icon: <FaChartLine className="text-gray-500" />,
              description: 'Adicione um nível',
          },
          {
            type: 'metrics',
            label: 'Métricas',
            icon: <FaChartLine className="text-gray-500" />,
            description: 'Adicione uma métrica',
        },

        
    ],
},
{
  group: 'Captura',
  elements: [
      {
          type: 'form', 
          label: 'Formulário',
          icon: <FaRegKeyboard className="text-gray-500" />,
          description: 'Adicione um nome',
      },
      
  ],
},
 
{
  group: 'Outros',
  elements: [
      {
          type: 'space',
          label: 'Espaço',
          icon: <FaRegKeyboard className="text-gray-500" />,
          description: 'Adicione um espaço',
      },
     
      
      {
          type: 'testimonial',
          label: 'Depoimento',
          icon: <FaRegComment className="text-gray-500" />,
          description: 'Adicione um depoimento',
      },
      {
        type: 'price',
        label: 'Preço',
        icon: <FaDollarSign className="text-gray-500" />,
        description: 'Adicione um preço',
    },
    {
      type: 'script',
      label: 'Script',
      icon: <FaCode className="text-gray-500" />,
      
      description: 'Adicione um script',
  },
  ],
},
];

function onMouseDown(e) {
  e.preventDefault();
   
}

// Draggable sidebar element button
function SidebarElementButton({ element, onStartDrag, showGhostBlock, setShowGhostBlock, el, setEl, 
  blocks, setBlocks, setDragingElement, setActiveIndex, haveTempBlock, setHaveTempBlock }) {

    const [isDragging, setIsDragging] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    // Add useEffect to monitor haveTempBlock changes
    useEffect(() => {
      
    }, [haveTempBlock]);

    const { attributes, listeners, setNodeRef } = useDraggable({
      id: `sidebar-element-${element.type}`,
      data: { 
        fromSidebar: true, 
        element,
        type: element.type,
        label: element.label,
        icon: element.icon
      },
    });

    useEffect(() => {
      if (!isDragging) return;

        const handleMouseMove = (e) => {
          setMousePosition({ x: e.clientX, y: e.clientY });
        // If the mouse is over a sortable context, alert "teste" 

          if(e.target.closest('#dnd-sortable-context')){
            
            document.getElementById('ghost-block').style.display = 'none';
            if(document.getElementById('temp-block')){
              document.getElementById('temp-block').style.display = 'block';
            }
          }else{
            
            document.getElementById('ghost-block').style.display = 'block';
            if(document.getElementById('temp-block')){
              document.getElementById('temp-block').style.display = 'none';
            }
          }
       
        }

      const handleMouseUp = () => {
        setIsDragging(false);
       
      };

      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        
      };
    }, [isDragging]);
    
    return (
      <>
        <button
            id={`ghost-sidebar-element-${element.type}`}
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            onMouseDown={(e) => {
              e.preventDefault();
             
              setIsDragging(true);
              setMousePosition({ x: e.clientX, y: e.clientY });
              if (onStartDrag) onStartDrag(element);


            }}
            className={`flex flex-row items-center justify-center gap-1 px-2 py-3 bg-white rounded-lg shadow hover:bg-blue-50 border border-gray-200 cursor-grab active:cursor-grabbing transition w-full ${isDragging ? 'opacity-50' : ''}`}
            title={element.description}
            type="button"
        >
            <span className="text-sm">{element.icon}</span>
            <span className="font-medium text-gray-800 text-sm text-left">{element.label}</span>
        </button>

        {isDragging && createPortal(
          <div id="ghost-block"
            style={{
              position: 'fixed',
              left: mousePosition.x,
              top: mousePosition.y,
              transform: 'translate(-50%, -50%) rotate(3deg)',
              zIndex: 9999,
              pointerEvents: 'none',
            }}
          >
            <div className="rounded-xl p-3 shadow-lg bg-white w-[300px]">
           
                <div className="flex items-center gap-2">
                  <span className="text-2xl">{element.icon}</span>
                  <span className="font-medium">{element.label}</span>
                </div>
            
            </div>
          </div>,
          document.body
        )}
      </>
    );
}

export default function StepElementsSidebar({ onStartDrag, showGhostBlock, setShowGhostBlock,
  el, setEl, blocks, setBlocks, setDragingElement, setActiveIndex, haveTempBlock, setHaveTempBlock,
   node, onNodeChange, updateNode, updateNode2, funnelNodes, setNodes, nodes, settingsFunnel, setSettingsFunnel }) {
    
    const [showLibraryModal, setShowLibraryModal] = useState(false);

    const handleLogoSelect = (imageUrl, media) => {
        onNodeChange(node.id, { ...node.data, logo: imageUrl });
        // Also update the funnel logo if needed
        if (typeof updateNode === 'function') {
            setSettingsFunnel({ ...settingsFunnel, logo: imageUrl });
        }
        setShowLibraryModal(false);
    };

    return (
        <div className="flex flex-col h-full w-full p-4 pr-7 bg-white">

      <h2 className="text-lg font-bold mb-4 text-gray-700">Config. Etapa:</h2>
      <div className="flex flex-col gap-6 w-full">
        <div className="flex flex-row gap-2">
         <div className="flex flex-col gap-2 w-full">
            <label className="inline-flex items-center gap-2">
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={node.data.showLogo}
                onChange={(e) => {
                  onNodeChange(node.id, { ...node.data, showLogo: e.target.checked });
                }}
              />
              <span className="text-gray-700 text-sm">Mostrar Logo</span> 
              <button
                type="button"
                className="mt-1 text-xs  text-blue-500  transition-colors"
                onClick={() => setShowLibraryModal(true)}
              >
                Alterar Logo
              </button>
            </label>
            <label className="inline-flex items-center gap-2">
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={node.data.showProgress}
                onChange={(e) => {
                  onNodeChange(node.id, { ...node.data, showProgress: e.target.checked });
                }}
              />
              <span className="text-gray-700 text-sm">Mostrar Barra de Progresso</span>
            </label>
            <label className="inline-flex items-center gap-2">
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={node.data.showBack}
                onChange={(e) => {
                  onNodeChange(node.id, { ...node.data, showBack: e.target.checked });
                }}
              />
              <span className="text-gray-700 text-sm">Mostrar "Voltar"</span>
            </label>

            <label className="inline-flex items-center gap-2">
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={node.data.isLastStep}
                onChange={(e) => {
                  onNodeChange(node.id, { ...node.data, isLastStep: e.target.checked });
                }}
              />
              <span className="text-gray-700 text-sm">Última etapa</span>
            </label>
         </div>


         </div>
        </div>

            <h2 className="text-lg font-bold mb-4 text-gray-700">Elementos</h2>
            <div className="flex flex-col gap-6 w-full">
                {ELEMENT_GROUPS.map((group, idx) => (
                    <div key={group.group} className="flex flex-col w-full">
                        <div className="text-md font-semibold text-gray-600 mb-2">{group.group}:</div>
                        <div className="grid grid-cols-3 gap-3 w-full">
                            {group.elements.map((el) => (
                                <SidebarElementButton
                                    key={el.type}
                                    element={el}
                                    onStartDrag={onStartDrag}
                                    onMouseDown={onMouseDown}
                                    showGhostBlock={showGhostBlock}
                                    setShowGhostBlock={setShowGhostBlock}
                                    setEl={setEl}
                                    blocks={blocks}
                                    setBlocks={setBlocks}
                                    setDragingElement={setDragingElement}
                                    setActiveIndex={setActiveIndex}
                                    haveTempBlock={haveTempBlock}
                                    setHaveTempBlock={setHaveTempBlock}
                                />
                            ))}
                            {/* ... */}
                        </div>
                    </div>
                ))}
            </div>

            <LibraryModal
                open={showLibraryModal}
                onClose={() => setShowLibraryModal(false)}
                onSelect={handleLogoSelect}
            />
        </div>
    );
}
